import { simpleFetch } from "./acCommon"
import * as actions from "./acLogin"

export const SIGNUP_DATACHANGE = 'SIGNUP_DATACHANGE'
export const signUpDataChange = changes => ({ type: SIGNUP_DATACHANGE, changes })

export const SIGNUP_METACHANGE = 'SIGNUP_METACHANGE'
export const signUpMetaChange = changes => ({ type: SIGNUP_METACHANGE, changes })

export const processDataChange = changes => (dispatch, getState) => {

	dispatch(signUpDataChange(changes))

	let { first_name, last_name, email, password, password_confirmation, telephone, title, accept_cgu } = getState().dataReducer.signup
	
	if (email !== '' && password !== '' && first_name !== '' && last_name !== '' && password === password_confirmation && telephone !== '' && title !== '' && accept_cgu) {
		dispatch(signUpMetaChange({ canSubmit: true }))
	}
	else {
		dispatch(signUpMetaChange({ canSubmit: false }))
	}

	if (password === password_confirmation) {
		dispatch(signUpMetaChange({ password_match: true }))
	}
	else {
		dispatch(signUpMetaChange({ password_match: false }))
	}

}

export const SIGNUP = 'SIGNUP'
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE'

export const signup = () => (dispatch, getState) => {

	let {
		dataReducer: {
			signup: { email, password, password_confirmation, first_name, last_name, telephone, title }
		},
		i18nState
	} = getState()

	let body = JSON.stringify({
		email: email,
		password: password,
		password_confirmation: password_confirmation,
		first_name: first_name,
		last_name: last_name,
		telephone: telephone,
		default_language: i18nState.lang,
		title: title
	})

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_sign_up',
	}

	dispatch(simpleFetch('/customers/sign_up/', {
		method: 'POST',
		body: body
	}, SIGNUP, requestMeta)).then(({ actionType, response, requestMeta }) => {
		if (actionType === SIGNUP_SUCCESS) {
			dispatch(actions.sign_in_call(email, password))
		}
	})
}



// WEBPACK FOOTER //
// ./src/actions/acSignup.js